import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import { useTranslation } from 'react-i18next';
import Table from 'src/components/Table';
import useStyles from '../styles';
import PaymentsFailuresRow from './PaymentsFailuresRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ paymentFailures }) =>
  paymentFailures.map(payment => (
    <PaymentsFailuresRow key={payment.id} {...payment} />
  ));

const PaymentsFailuresTable = ({
  className,
  paymentFailures,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell
          variant="head"
          key="contractFolio"
          sx={{ width: '10%' }}
          align="center"
        >
          {t('ENUMS.AUTOMATIC_DEBIT.CONTRACT_FOLIO')}
        </TableCell>
        <TableCell
          variant="head"
          key="client"
          sx={{ width: '10%' }}
          align="center"
        >
          {t('ENUMS.AUTOMATIC_DEBIT.CLIENT_NAME')}
        </TableCell>
        <TableCell
          variant="head"
          key="amount"
          sx={{ width: '10%' }}
          align="center"
        >
          {t('ENUMS.AUTOMATIC_DEBIT.AMOUNT')}
        </TableCell>
        <TableCell
          variant="head"
          key="log"
          sx={{ width: '10%' }}
          align="center"
        >
          {t('ENUMS.AUTOMATIC_DEBIT.ERROR')}
        </TableCell>
        <TableCell
          variant="head"
          key="dueDate"
          sx={{ width: '10%' }}
          align="center"
        >
          {t('ENUMS.AUTOMATIC_DEBIT.DUE_DATE')}
        </TableCell>
        <TableCell
          variant="head"
          key="contractFolio"
          sx={{ width: '10%' }}
          align="center"
        />
      </TableRow>
    ),
    [classes]
  );

  const tbody = useMemo(
    () => () => <Tbody t={t} paymentFailures={paymentFailures} />,
    [paymentFailures, t]
  );

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, paymentFailures]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

PaymentsFailuresTable.propTypes = {
  className: PropTypes.string,
  paymentFailures: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

PaymentsFailuresTable.defaultProps = {
  count: 0
};

export default PaymentsFailuresTable;
